import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';

export default function Cancel() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center h-full bg-slate-50">
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 max-w-md text-center">
        <div className="w-14 h-14 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle size={28} />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">Checkout Cancelled</h1>
        <p className="text-slate-500 mb-6">
          No charges were made. You can subscribe at any time to access the full platform.
        </p>
        <div className="space-y-3">
          <button
            onClick={() => navigate('/checkout')}
            className="w-full py-3 px-4 bg-[#043132] hover:bg-[#065354] text-white font-bold rounded-xl transition-colors flex items-center justify-center gap-2"
          >
            <CreditCard size={16} /> Try Again
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full py-2.5 px-4 text-slate-600 hover:text-slate-800 text-sm font-medium flex items-center justify-center gap-1.5 transition-colors"
          >
            <ArrowLeft size={14} /> Return to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
